module.exports = __webpack_public_path__ + "img/step2.c1a04731.png";